export enum FilterDataSources {
    Users = "Users",
    Priorities = "Priorities",
    Statuses = "Statuses",
    TaskTypes = "TaskTypes",
    Binary = "Binary"
}